export const OVERLAPPING_BANNER_TEXT = {
	title: 'Activities overlapping.',
	description:
		'Error occurred. You are trying to create an activity that overlaps with existing ones:',
};

export const CANNOT_CANCEL_OVERLAPPING_BANNER_TEXT = {
	title: 'Activities overlapping.',
	description: 'These activities cannot be cancelled:',
};

export const OVERLAPPING_ACTION_LABEL = 'Overlapping activity action';

export const OVERLAPPING_ACTION_OPTIONS = {
	DELETE: 'delete',
	DELAY: 'delay',
};

export const OVERLAPPING_ACTION_OPTION_LABELS = {
	[OVERLAPPING_ACTION_OPTIONS.DELETE]: 'Delete overlapping activities and create the new one',
	[OVERLAPPING_ACTION_OPTIONS.DELAY]: 'Add a delay to the activity being created',
};

export const DELAY_LABEL = 'Delay';
export const MINIMUM_RECOMMENDED_DELAY_TEXT = 'Minimum recommended delay:';
